const benefits = [
  { icon: "ri-fire-line", label: "Alta demanda de serviços" },
  { icon: "ri-money-dollar-circle-line", label: "Pagamentos justos e recorrentes" },
  { icon: "ri-links-line", label: "Parcerias contínuas" },
  { icon: "ri-award-line", label: "Projetos de padrão premium" },
  { icon: "ri-line-chart-line", label: "Oportunidade de crescimento" },
];

const steps = [
  { num: "01", text: "Você se cadastra" },
  { num: "02", text: "Analisamos seu perfil" },
  { num: "03", text: "Aprovação e início dos serviços" },
];

const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

export default function TrabalheConosco() {
  return (
    <section
      id="trabalhe-conosco"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{ backgroundColor: "#faf8f5" }}
    >
      {/* Decorative accent */}
      <div className="absolute top-0 left-0 w-full h-1" style={{ background: "linear-gradient(90deg, transparent, #b45309, transparent)" }} />
      <div className="absolute -top-32 -right-32 w-80 h-80 rounded-full opacity-5" style={{ background: "radial-gradient(circle, #b45309, transparent)" }} />
      <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full opacity-5" style={{ background: "radial-gradient(circle, #b45309, transparent)" }} />

      <div className="max-w-6xl mx-auto px-5 md:px-10">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">
            Oportunidade
          </p>
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-stone-800 mb-4 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Trabalhe com a Vynora
          </h2>
          <p className="text-stone-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Buscamos profissionais comprometidos que desejam crescer e ter renda constante com projetos de alto padrão.
          </p>
        </div>

        {/* Main grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">

          {/* Left — info */}
          <div>
            {/* Benefits */}
            <div className="mb-10">
              <p className="text-stone-400 text-xs font-semibold uppercase tracking-widest mb-5">
                O que oferecemos
              </p>
              <ul className="flex flex-col gap-3">
                {benefits.map((b) => (
                  <li key={b.label} className="flex items-center gap-3.5">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: "#fef3c7" }}>
                      <i className={`${b.icon} text-amber-700 text-base`} />
                    </div>
                    <span className="text-stone-700 text-sm font-medium">{b.label}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Profile */}
            <div className="rounded-xl p-5 mb-8 border border-amber-100" style={{ backgroundColor: "#fffbf0" }}>
              <p className="text-amber-700 text-xs font-bold uppercase tracking-widest mb-2">
                Perfil buscado
              </p>
              <p className="text-stone-600 text-sm leading-relaxed">
                Procuramos <strong className="text-stone-800">instaladores de pisos vinílicos</strong> e profissionais da área que prezam por qualidade, organização e bom acabamento.
              </p>
            </div>

            {/* Steps */}
            <div>
              <p className="text-stone-400 text-xs font-semibold uppercase tracking-widest mb-5">
                Como funciona
              </p>
              <div className="flex flex-col gap-4">
                {steps.map((s, i) => (
                  <div key={s.num} className="flex items-center gap-4">
                    <div className="flex flex-col items-center">
                      <div
                        className="w-8 h-8 flex items-center justify-center rounded-full text-xs font-bold text-white flex-shrink-0"
                        style={{ backgroundColor: "#b45309" }}
                      >
                        {s.num}
                      </div>
                      {i < steps.length - 1 && (
                        <div className="w-px h-5 mt-1" style={{ backgroundColor: "#d97706" }} />
                      )}
                    </div>
                    <span className="text-stone-600 text-sm">{s.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right — CTA card */}
          <div>
            <div className="bg-white rounded-2xl p-8 md:p-10 border border-stone-100 text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6" style={{ backgroundColor: "#fef3c7" }}>
                <i className="ri-user-add-line text-amber-700 text-2xl" />
              </div>
              <h3
                className="text-xl md:text-2xl font-bold text-stone-800 mb-3"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Faça parte do nosso time
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed mb-8">
                Entre em contato pelo WhatsApp e nossa equipe dará continuidade ao seu cadastro.
              </p>
              <a
                href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20quero%20me%20cadastrar%20como%20parceiro"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-sm px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base" />
                Quero me cadastrar
              </a>
              <div className="mt-5 flex items-center justify-center gap-2 text-stone-400 text-xs">
                <i className="ri-shield-check-line text-amber-600" />
                Seus dados estão seguros conosco
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}